<template>
  <div class="my_title_combination">
    <my_title
      :inputValue.sync="infor.title.text.value"
      :checkboxValue.sync="infor.title.text.isHidden"
      :titleWidth="'auto'"
    ></my_title>

    <template v-if="infor.title.text.isHidden == false">
      <my_font_size
        titleWidth="65"
        hiddenIsShow="false"
        :fontSizeOption="$store.state.options.newFontSize"
        :radioValue.sync="infor.title.font.radio_val"
        :fontFamily.sync="infor.title.font.custom.fontFamily"
        :fontSize.sync="infor.title.font.custom.fontSize"
        :colorValue.sync="infor.title.font.custom.fontColor_globalColor"
        :fsWeight.sync="infor.title.font.custom.fsWeight"
        :fsItalics.sync="infor.title.font.custom.fsItalics"
        :fsUnderline.sync="infor.title.font.custom.fontUnderline"
        :textAlign.sync="infor.title.font.custom.textAlign"
        :pattern.sync="infor.title.font.custom.pattern"
        :linearGradient.sync="infor.title.font.custom.linear_gradient"
      ></my_font_size>

      <div class="radio_input">
        <my_radio
          :title="$t('widgets_basic_article_list_edit_373')"
          hiddenIsShow="false"
          titleWidth="65"
          :selectValue.sync="infor.title.height.radio_val"
          :option="$store.state.options.default_custom"
        ></my_radio>
        <my_input_number
          :value.sync="infor.title.height.custom.height"
          titleWidth="0"
          class="input_num"
          v-if="infor.title.height.radio_val === 'custom'"
          :min="0"
          :max="200"
        ></my_input_number>
      </div>

      <my_background
        titleWidth="65"
        :colorTitle="$t('widgets_basic_article_list_edit_394')"
        :radioValue.sync="infor.title.background.radio_val"
        :bgType.sync="infor.title.background.custom.type"
        :imgUrl.sync="infor.title.background.custom.img"
        @imgScaleChange="(img_scale)=>{
          let options = this.$store.state.options.backGroundImageList
          infor.title.background.custom.background_size = options[img_scale].background_size
          infor.title.background.custom.background_repeat = options[img_scale].background_repeat
          infor.title.background.custom.background_position = options[img_scale].background_position
        }"
        @tileEffectChange="(tile_effect)=>{
          let options = this.$store.state.options.backGroundImageList
          infor.title.background.custom.background_size = options[tile_effect].background_size
          infor.title.background.custom.background_repeat = options[tile_effect].background_repeat
          infor.title.background.custom.background_position = options[tile_effect].background_position
        }"
        :imgScale.sync="infor.title.background.custom.img_scale"
        :tileEffect.sync="infor.title.background.custom.tile_effect"
        :imgPos.sync="infor.title.background.custom.background_position"
        :colorValue.sync="infor.title.background.custom.color"
      ></my_background>
    </template>
  </div>
</template>

<script>
import i18n from '../../language/index'

export default {
  name: "my_title_combination",
  props: {
    infor: {
      type: Object,
      default: {}
    },
  },
  created(){    
    if(!this.infor.title.text.isHidden){
      this.infor.title.font.default.fontColor_globalColor = this.$store.state.myRender.common.theme_color;
    }
  },
  watch: {
    'infor.title.text.isHidden' (val) {
      if (!val) {
        this.infor.title.font.default.fontColor_globalColor = this.$store.state.myRender.common.theme_color;
      }

    },
    'infor.title.font.radio_val'(val){
      if(val == 'default'){
        this.templet.ergodic_module_attr(this.$store.state.app.module_Data.data, 'data')
      }

    }
  }
}
</script>

<style scoped lang="scss">
.radio_input {
  position: relative;
  /deep/ .input_num {
    position: absolute;
    top: 0;
    right: 50px;
    width: 70px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/my_title_combination/index.vue